var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionAltitudeAverage16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c.254 0 .496.11.662.302l2.16 2.493A.729.729 0 0 1 14.272 6H13v2a1 1 0 1 1-2 0V6H9.728a.728.728 0 0 1-.55-1.205l2.16-2.493A.876.876 0 0 1 12 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.752 6.432 3.196 5.478c.016.029.029.059.038.09H14a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h.014a.383.383 0 0 1 .038-.09l3.196-5.478a.87.87 0 0 1 1.504 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionAltitudeAverage16);
export default __webpack_public_path__ + "static/media/ic_action_altitude_average_16.104583306b6f1d1a43191e7503cab7bd.svg";
export { ForwardRef as ReactComponent };